/* eslint-disable jsx-a11y/anchor-is-valid */
import { Row, Col } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import { formatPathByLogicalGroupChannel } from "src/utils/url";
import Link from "../../Common/Link";
import {
  ButtonSectionContainer,
  ButtonText,
  DesktopErrorImageContainer,
  EntryFormButton,
  ErrorContainer,
  ErrorImage,
  ErrorMobileContainer,
  ErrorMobileTitle,
  ErrorTitle,
  ListItemBody,
  PlanButton,
  UnorderList,
} from "./NotFoundDirectLinkError.style";

export type NotFoundDirectLinkErrorProps = {
  onOpenEntryForm: Function;
  onGoToPlanPage: Function;
  channelPath: string;
};

const NotFoundDirectLinkError = ({
  onOpenEntryForm = () => {},
  onGoToPlanPage = () => {},
  channelPath,
}: NotFoundDirectLinkErrorProps) => {
  const { lg } = useBreakpoint();
  const { t } = useTranslation("plan-content-direct-link");

  const [isLoadingGoToPlan, setIsLoadingGoToPlan] = useState<boolean>(false);

  const onClickOpenEntryForm = () => {
    onOpenEntryForm();
  };

  const onClickGoToPlanPage = () => {
    setIsLoadingGoToPlan(true);
    onGoToPlanPage();
  };

  return (
    <>
      {lg ? (
        <Row justify="center" gutter={[40, 0]} align="top">
          <DesktopErrorImageContainer>
            <ErrorImage
              width={324}
              height={324}
              alt=""
              src="/static/pages/planContentDirectLink/not-match-error.svg"
            />
          </DesktopErrorImageContainer>
          <Col>
            <ErrorContainer>
              <ErrorTitle>{t("errorPage.searchNotFound.title")}</ErrorTitle>
              <UnorderList>
                <li>
                  <ListItemBody>
                    {t("errorPage.searchNotFound.detail1")}
                  </ListItemBody>
                </li>
                <li>
                  <ListItemBody>
                    {t("errorPage.searchNotFound.detail2")}
                    <Link
                      href={formatPathByLogicalGroupChannel(`/${channelPath}`)}
                    >
                      <a target="">
                        {t("errorPage.searchNotFound.detail2Link")}
                      </a>
                    </Link>
                  </ListItemBody>
                </li>
                <li>
                  <ListItemBody>
                    {t("errorPage.searchNotFound.detail3")}
                    <Link href="tel:+6620263355">
                      {t("errorPage.searchNotFound.detail3Link")}
                    </Link>
                    {t("errorPage.searchNotFound.detail3Tail")}
                  </ListItemBody>
                </li>
              </UnorderList>
            </ErrorContainer>
            <ButtonSectionContainer>
              <EntryFormButton
                data-testid="open-entry-form-button"
                data-gtm-input-code="open-entry-form-button"
                fullWidth
                onClick={onClickOpenEntryForm}
              >
                <ButtonText>
                  {t("errorPage.searchNotFound.openEntryForm")}
                </ButtonText>
              </EntryFormButton>
              <PlanButton
                data-testid="go-to-plan-button"
                data-gtm-input-code="go-to-plan-button"
                fullWidth
                onClick={onClickGoToPlanPage}
                loading={isLoadingGoToPlan}
                type="outlined"
              >
                <ButtonText>
                  {t("errorPage.searchNotFound.goToPlanButton")}
                </ButtonText>
              </PlanButton>
            </ButtonSectionContainer>
          </Col>
        </Row>
      ) : (
        <Row justify="center" align="middle">
          <Col span={24}>
            <Row justify="center" align="middle">
              <ErrorImage
                width={200}
                height={200}
                alt=""
                src="/static/pages/planContentDirectLink/not-match-error.svg"
              />
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="center" align="middle">
              <ErrorMobileContainer>
                <ErrorMobileTitle>
                  {t("errorPage.searchNotFound.title")}
                </ErrorMobileTitle>
                <UnorderList>
                  <li>
                    <ListItemBody>
                      {t("errorPage.searchNotFound.detail1")}
                    </ListItemBody>
                  </li>
                  <li>
                    <ListItemBody>
                      {t("errorPage.searchNotFound.detail2")}
                      <Link
                        href={formatPathByLogicalGroupChannel(
                          `/${channelPath}`
                        )}
                        target=""
                      >
                        {t("errorPage.searchNotFound.detail2Link")}
                      </Link>
                    </ListItemBody>
                  </li>
                  <li>
                    <ListItemBody>
                      {t("errorPage.searchNotFound.detail3")}
                      <Link
                        href={formatPathByLogicalGroupChannel(
                          `/${channelPath}`
                        )}
                      >
                        <a target="">
                          {t("errorPage.searchNotFound.detail3Link")}
                        </a>
                      </Link>
                      {t("errorPage.searchNotFound.detail3Tail")}
                    </ListItemBody>
                  </li>
                </UnorderList>
              </ErrorMobileContainer>
              <ButtonSectionContainer>
                <EntryFormButton
                  data-testid="open-entry-form-button"
                  data-gtm-input-code="open-entry-form-button"
                  fullWidth
                  onClick={onClickOpenEntryForm}
                >
                  <ButtonText>
                    {t("errorPage.searchNotFound.openEntryForm")}
                  </ButtonText>
                </EntryFormButton>
                <PlanButton
                  data-testid="go-to-plan-button"
                  data-gtm-input-code="go-to-plan-button"
                  fullWidth
                  onClick={onClickGoToPlanPage}
                  loading={isLoadingGoToPlan}
                  type="outlined"
                >
                  <ButtonText>
                    {t("errorPage.searchNotFound.goToPlanButton")}
                  </ButtonText>
                </PlanButton>
              </ButtonSectionContainer>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default NotFoundDirectLinkError;
